import * as _ from "lodash";
import * as $ from "jquery";
import {BaseList, TableProperties} from "../../_BaseList";
import {UserOverviewView} from "./UserOverviewView";
import {AddUserModal} from "../team/TeamModals";
import {BaseAccountListView, BaseAccountViewOptions} from "../_BaseAccountViews";

require('bootstrap-toggle');

export class UserAccountView extends BaseAccountListView {

    constructor(options: BaseAccountViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-user': 'handleCreateUserButtonClick',
            }
        }));
    }

    show(orgId, userId?, detail?, subDetail?) {
        if (userId) {
            var view = new UserOverviewView(_.extend({}, this.options));

            this.$el.empty().append(view.render().$el);
            view.show(userId, detail, subDetail);
            this.subViews.push(view);
            return;
        }

        this.collectionLoaded = true;
        this.render();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
    }

    render() {
        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            currentOrganizationId: this.options.currentOrganizationId,
            collectionLoaded: this.collectionLoaded,
            urlAddon: '/users',
        }));

        var userGroupIds = this.options.userGroupCollection.map((m) => {
            return m.get('id')
        });
        var canAddUser = _.some(userGroupIds.map(
            this.options.permissionCollection.canAddUserToUserGroup.bind(this.options.permissionCollection)
        ));
        this.$('.container').append(this.panelTemplate({
            panelTitle: {text: 'Users', url: null},
            panelClass: 'users',
            panelWidth: '',
            headerLink: null,
            addButton: {canAdd: canAddUser, label: "Add User", 'class': "add-user"},
            search: true,
            collectionLoaded: this.collectionLoaded,
            footer:null
        }));

        this.showBreadcrumbs(this.options.organizationCollection.findWhere({id: this.options.currentOrganizationId}));
        if (this.collectionLoaded) this.showTable();
        this.delegateEvents();
        return this;
    }

    showTable() {
        var table = new BaseList(this.options);
        var tableProperties: TableProperties = {
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/users/',
            tableEmptyText: 'There are no Users',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Email': {
                    attribute: 'email',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Phone Number': {
                    attribute: 'phone_number',
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '12'
                    }
                },
                'Teams': {
                    attribute: 'usergroups',
                    customColumn: {
                        templateFunction: _.template('<% var usergroups = []; %> ' +
                            ' <% _.each(mod.get("usergroups"), function(g, id) { %> ' +
                            ' <% var ugroup  = userGroupCollection.findWhere({id: Number(id)}) %>' +
                            ' <% if(ugroup) usergroups.push(ugroup.get("name"))%>' +
                            ' <% }); %>' +
                            ' <div class="col-md-3 col-sm-2 col-xs-10 account-modify-team-member-since" data-table-cell=<%- usergroups.sort().join(", ") %>>' +
                            ' <%- usergroups.sort().join(", ") %>' +
                            ' </div>'
                        ),
                        variables: {
                            userGroupCollection: this.options.userGroupCollection,
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                }
            }
        };
        this.$('.users .panel-body > .row').append(table.renderCollectionList(this.options.userCollection, tableProperties).$el);
    }

    showBreadcrumbs(org) {
        super.showBreadcrumbs('Users', 'Categories');
    }

    handleCreateUserButtonClick() {
        var view = new AddUserModal(_.extend({}, this.options, {
            userGroupCollection: this.options.userGroupCollection,
            userCollection: this.options.userCollection
        }));
        $('.modals').append(view.render().el);
        view.show();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/user/UserAccountView.ts